interface ToggleProps {
  label?: string
  checked: boolean
  onChange: (checked: boolean) => void
}

export const Toggle = ({ label, checked, onChange }: ToggleProps) => {
  return (
    <div className="flex items-center gap-3">
      {label &&
        <label className="block text-[14px] font-[600] text-foreground ">{label}</label>
      }
      <button
        onClick={() => onChange(!checked)}
        className={`relative w-[33.2px] h-[20px] rounded-full transition-colors ${
          checked ? 'bg-[#28282A]' : 'bg-gray-300'
        }`}
      >
        <div
          className={`absolute top-[1px] -left-1 w-[17.42px] h-[17.42px] bg-card rounded-full outline-none transition-transform ${
            checked ? 'translate-x-5' : 'translate-x-1'
          }`}
        />
      </button>
    </div>
  )
}